export default __webpack_public_path__ + "static/media/logo3.a4cdd336.png";